<section id="main">
  <div class="container">
    <div class="row main-row">
      <div class="tmplt-list-title col-md-12 p-r-0 m-b-15">
        <h2 translate="documents.header" class="title-style"></h2>
      </div>

      <div class="timeline-row col-sm-12">




        <div class="hypo-timeline-wrapper app-white-card ">

          <div class="row p-15" >
            <div class="col-sm-12 p-10 bgm-white" style="z-index:1;">
              <div class="col-sm-6 col-xs-12 p-0">
                <div class="tml-filter-container tmlf-wide" style="overflow: hidden;" id="searchFilterExpandedDiv">
                  <div id="searchBtnLeftDiv" class="inner-section left" >
                    <i class="icon icon-search  icon-hc-2x m-l-5"></i>
                  </div>
                  <div id="searchBtnCenterDiv" class="inner-section center">
                    <input id="searchTimelineInput" type="text" class="search-input" placeholder="{{'timelineFilter.placeholder'|translate}}"
                           ng-model="documents.timelineFilter.searchFTS" ng-model-options="{ debounce: 300 }"
                    >
                  </div>
                  <div ng-if="documents.country === 'hr'" id="searchBtnRightDiv" class="inner-section right pull-right" ng-init="documents.showDeleteInputBtn = false">
                      <i ng-show="documents.timelineFilter.searchFTS" class="zmdi zmdi-tag-close  zmdi-hc-2x m-r-0"
                        ng-click="documents.timelineFilter.searchFTS = ''; documents.showDeleteInputBtn = false"></i>
                      <i class="icon icon-filter i-p24 i-lh12 m-r-0 pull-right"
                        ng-click="documents.searchFilterExpanded = !documents.searchFilterExpanded"></i>

                  </div>
                  <div ng-if="documents.country === 'hr'"
                       class="tml-filter-selection" ng-class="{'opened': documents.searchFilterExpanded}">
                    <div class="col-xs-6 p-l-5 p-r-5">
                      <div class="form-group m-b-0">
                        <label class="f-12-s" translate="paymentsOverview.dateFrom">Date from</label>
                        <div class="input-group">
                          <input type="text" class="form-control-db"
                                ng-value="documents.timelineFilter.dateGTE | date: 'shortDate' : '+0200'"
                                readonly>
                          <span class="input-group-btn">
                              <button data-ng-click="documents.dateFromOpen = !documents.dateFromOpen" type="button"
                                      class="btn btn-default input-group-app-btn domp-btn-height z-zero"
                                      style="border:1px solid #062a42; height: 35px">
                                      <i class="icon icon-calendar" style="font-size: 21px;"></i>
                              </button>
                            </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-6 p-l-0 p-r-5">
                      <div class="form-group m-b-0">
                        <label class="f-12-s" translate="paymentsOverview.dateTo">Date to</label>
                        <div class="input-group">
                          <input type="text" class="form-control-db"
                                ng-value="documents.timelineFilter.dateLTE | date: 'shortDate' : '+0200'"
                                readonly>
                          <span class="input-group-btn">
                              <button data-ng-click="documents.dateToOpen = !documents.dateToOpen" type="button"
                                      class="btn btn-default input-group-app-btn domp-btn-height z-zero"
                                      style="border:1px solid #062a42; height: 35px">
                                      <i class="icon icon-calendar" style="font-size: 21px;"></i>
                              </button>
                            </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-xs-6 p-l-0 p-r-5">
                      <!-- Date from datepicker-->
                      <div data-ng-model="documents.timelineFilter.dateGTE"
                          show-weeks="false"
                          show-button-bar="false"
                          is-open="documents.dateFromOpen"
                          ng-change="documents.onDateFromChange()"
                          uib-datepicker-popup="shortDate"
                          datepicker-append-to-body="true"
                          current-text="{{'core.period.today' | translate}}"
                          clear-text="{{'core.datePicker.clearBtn' | translate}}"
                          close-text="{{'core.datePicker.doneBtn' | translate}}"
                          datepicker-options="documents.dateOptions"
                          required="">
                      </div>
                      <!-- Date to datepicker-->
                      <div data-ng-model="documents.timelineFilter.dateLTE"
                          show-weeks="false"
                          show-button-bar="false"
                          is-open="documents.dateToOpen"
                          ng-change="documents.onDateToChange()"
                          current-text="{{'core.period.today' | translate}}"
                          clear-text="{{'core.datePicker.clearBtn' | translate}}"
                          close-text="{{'core.datePicker.doneBtn' | translate}}"
                          date-disabled="documents.datesToDisabled(date, mode)"
                          datepicker-options="documents.dateOptions"
                          uib-datepicker-popup="shortDate"
                          datepicker-append-to-body="true">
                      </div>
                    </div>
                      <div class="row w-100 m-0 pt-3 pb-3" style="overflow:auto">
                          <div class="col-xs-6 t-a-l p-l-5">
                              <button class="btn btn-primary app-btn-gray ng-scope" ng-click=" documents.resetTimelineFilter();documents.searchFilterExpanded = false;documents.applyTimelineFilter();" translate="timelineFilter.reset">Poništi</button>
                          </div>
                          <div class="col-xs-6 t-a-r p-r-5">
                              <button class="btn btn-default app-btn-blue ng-scope" ng-click="documents.applyTimelineFilter();" translate="timelineFilter.apply">Primijeni</button>
                          </div>
                      </div>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-xs-12 p-0 p-r-10">
                <div class="dropdown acc-period-select pull-right" style="display: inline-block">
                  <button class="btn btn-default dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                    {{documents.selectedPeriod.item.description | translate}}
                    <span class="caret"></span>
                  </button>
                  <ul class="dropdown-menu" aria-labelledby="dropdownMenu1">
                    <li data-ng-repeat="period in documents.periodList">
                      <a href="" class="f-13" data-ng-click="documents.selectPeriod(period)">
                        {{period.item.description | translate}}
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>


          <div class="t-a-c m-t-10 p-10 no-data-image" ng-show="documents.timelineListGrouped.result.length == 0">
            <i class="zmdi zmdi-cloud-off zmdi-hc-5x"></i>
            <h3 class="no-data-label" translate="documents.noItemData"></h3>
          </div>
          <div class="timeline-row col-sm-12 p-l-0 p-r-0"
               ng-show="documents.timelineListGrouped.result.length > 0">
            <div class="hypo-timeline-wrapper app-white-card no-top-radius p-b-10">
              <ul class="hypo-timeline" >
                <li data-ng-repeat="item in documents.timelineListGrouped.result | filter:documents.timelineFilter.searchFTS" ng-class="{'time-label': item.isVirtual === true, 'tl-badge-icon': item.isVirtual === undefined}">
                  <span ng-if="item.isVirtual === true && documents.country == 'hr'" class="bg-white">{{item.date | date:'shortDate' }}</span>
                  <span ng-if="item.isVirtual === true && documents.country == 'sl'" class="bg-white">{{item.date }}</span>
                  <i ng-if="item.isVirtual == undefined" class="zmdi icon f-18 lh-27 c-nar icon-acrobat"></i>

                  <div ng-if="item.isVirtual == undefined" class="hypo-timeline-item">

                    <div class="hypo-timeline-body">
                      <div class="row">
                        <div class="col-md-9 col-sm-6 col-xs-12 t-a-l ">
                          <div class="row">
                            <div class="col-xs-12">
                              {{item.date | date}}
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-xs-12">
                              <span class="p-l-0 status-label">
                                <span ng-class="'mr-1 icon-download-status icon-download-status-' + (item.downloaded ? 'read' : 'unread')"></span>
                                <span ng-class="'download-status download-status-' + (item.downloaded ? 'read' : 'unread')">
                                      {{('documents.statuses.'+ (item.downloaded ? 'read' : 'unread')) | translate}}
                                      <span ng-if="item.dtDownloaded">{{item.dtDownloaded | date:'medium'}}</span>
                                </span>
                              </span>
                              <h4 ng-if="item.title" class="m-b-0 m-t-0 c-gray">
                                <b ng-if="item.unread">{{item.title}}</b>
                                <span ng-if="!item.unread">{{item.title}}</span>
                              </h4>
                            </div>
                          </div>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12 t-a-r">
                          <button type="input" class="btn btn-default app-btn-orange m-b-0" translate="documents.download"
                                  ng-disabled="item.downloadPdfInProgress"
                                  ng-click="documents.downloadPdf(item)"></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>


        </div>


      </div>

    </div>
    <div class="row">
      <div class="show-more-btn">
        <button ng-show="documents.timelineListGrouped.hasMore" data-ng-click="documents.loadMoreTimelineItemsGrouped()" type="input" class="btn btn-default app-btn-blue-inverse show-all-accounts-btn load-events-btn" translate="documents.loadEvents">Load older events</button>
      </div>
    </div>
  </div>
</section>
